import * as React from "react";
import Box from "@mui/material/Box";
import { colors } from "../../theme";

export const NullTableElement: React.FC = (): JSX.Element => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                backgroundColor: colors.white.main,
            }}
        >
            <Box sx={{ pb: 10, pt: 10 }}>該当する検索結果はありません</Box>
        </Box>
    );
};

export const LoadingTableElement: React.FC = (): JSX.Element => {
    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                backgroundColor: colors.white.main,
            }}
        >
            <Box sx={{ pb: 10, pt: 10 }}>読み込み中</Box>
        </Box>
    );
};
